import { render, staticRenderFns } from "./textBookReader_v2.vue?vue&type=template&id=e5dd3428&"
import script from "./textBookReader_v2.vue?vue&type=script&lang=js&"
export * from "./textBookReader_v2.vue?vue&type=script&lang=js&"
import style0 from "./textBookReader_v2.vue?vue&type=style&index=0&id=e5dd3428&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports